var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "comment-answer__inner" }, [
    _c("div", { staticClass: "comment-wrapper" }, [
      _c(
        "div",
        { staticClass: "comment", attrs: { id: _vm.idSelector } },
        [
          _c("CommentHeader", {
            attrs: {
              comment: _vm.comment,
              "comment-answer-to": _vm.commentAnswerTo
            }
          }),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "comment__content comment__content--reply" },
            [
              _c("CommentText", { attrs: { comment: _vm.comment } }),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "comment__bottom" },
                [
                  _vm.isCommentShowing
                    ? _c("ReplyBtn", {
                        attrs: { "replay-to-id": _vm.comment.id }
                      })
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.isCommentShowing
                    ? _c("MoreActionsBtn", { attrs: { comment: _vm.comment } })
                    : _vm._e(),
                  _vm._v(" "),
                  _c("LikeBtn", {
                    attrs: { comment: _vm.comment, "is-mobile": true }
                  })
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ]),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "comment-reply-wrapper comment-reply-wrapper--reply" },
      [
        _c(
          "transition",
          { attrs: { name: "comment-input-fade" } },
          [
            _c("Input", {
              key: _vm.comment.id,
              attrs: { "answer-to-id": _vm.comment.id }
            })
          ],
          1
        )
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }